import React from 'react';
import { painPoints } from '../data/content';
export function PainSection() {
  return <section className="bg-brand-cream px-4 py-5 sm:px-6" aria-labelledby="pain-heading" data-id="element-114" data-mp="38xomh5fo52zr">
      <div className="mb-3 text-center" data-id="element-115" data-mp="2uyfeuu5j3h7e">
        <h2 id="pain-heading" className="mb-1 font-heading text-xl uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-116" data-mp="2uxdshtj2b8ad">
          Vous vous reconnaissez ?
        </h2>
        <p className="mx-auto max-w-xl text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-117" data-mp="2l7kg4qb3ip52">
          Vous aimez entraîner le padel. Vous aimez voir vos joueurs progresser, améliorer leur
          technique et prendre de meilleures décisions au fil des entraînements. Mais préparer chaque
          séance vous demande souvent beaucoup plus de temps que prévu. Que vous travailliez dans un
          club, une académie, un centre sportif ou en cours privés, vous vous reconnaîtrez
          probablement dans ces situations.
        </p>
      </div>
      <div className="mx-auto max-w-xl space-y-2" data-id="element-118" data-mp="3rmr41xb0cn1h">
        {painPoints.map(point => <article key={point.title} className="rounded-lg border-l-4 border-brand-green bg-white p-3 shadow-sm" data-id="element-119" data-mp="3nlfl2amn3029">
            <h3 className="mb-1 font-heading text-[13px] uppercase leading-tight text-brand-navy sm:text-base" data-id="element-120" data-mp="5ehmuob8zpmo">
              {point.emoji} {point.title}
            </h3>
            {point.paragraphs.map(paragraph => <p key={paragraph} className="mb-1 text-[11px] font-medium leading-snug text-brand-ink/80 last:mb-0 sm:text-xs" data-id="element-121" data-mp="38uggdaoxcvny">
                {paragraph}
              </p>)}
            {point.bullets && <ul className="mt-1 space-y-0.5" data-id="element-122" data-mp="3duue9zwtap89">
                {point.bullets.map(bullet => <li key={bullet} className="text-[11px] font-bold leading-snug text-brand-navy sm:text-xs" data-id="element-123" data-mp="2q4qmcpszkdx3">
                    • {bullet}
                  </li>)}
              </ul>}
          </article>)}
      </div>
    </section>;
}